/* Public proof line under the mic: how much music only BEATSEEK can name. */
import React, { useEffect, useRef, useState } from 'react';
import { Dna } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const useCountUp = (target) => {
  const [n, setN] = useState(0);
  const raf = useRef(null);
  useEffect(() => {
    if (!target) return setN(0);
    const start = performance.now();
    const from = 0;
    const step = (t) => {
      const p = Math.min(1, (t - start) / 900);
      setN(Math.round(from + (target - from) * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf.current = requestAnimationFrame(step);
    };
    raf.current = requestAnimationFrame(step);
    return () => raf.current && cancelAnimationFrame(raf.current);
  }, [target]);
  return n;
};

export const IndexCounter = () => {
  const [stats, setStats] = useState(null);
  const edits = useCountUp(stats?.edits || 0);
  const ids = useCountUp(stats?.matches || 0);

  useEffect(() => {
    let dead = false;
    fetch(`${API}/api/community-index/stats`)
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (!dead && d && d.edits > 0) setStats(d); })
      .catch(() => {});
    return () => { dead = true; };
  }, []);

  if (!stats) return null;

  return (
    <div
      data-testid="community-index-counter"
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7,
        margin: '14px auto 0', fontSize: '0.72rem', letterSpacing: '0.03em',
        color: 'rgba(255,255,255,0.4)', textAlign: 'center', flexWrap: 'wrap',
      }}
    >
      <Dna size={12} style={{ color: '#f7d55c', opacity: 0.8, flexShrink: 0 }} />
      <span>
        <strong style={{ color: '#f7d55c', fontWeight: 700 }} data-testid="index-counter-edits">{edits.toLocaleString()}</strong>
        {' '}{stats.edits === 1 ? 'track' : 'tracks'} no other app can name
        {stats.matches > 0 && (
          <>
            {' · '}
            <strong style={{ color: 'rgba(255,255,255,0.62)', fontWeight: 700 }} data-testid="index-counter-ids">{ids.toLocaleString()}</strong>
            {' '}named so far
          </>
        )}
      </span>
    </div>
  );
};

export default IndexCounter;
